'use client'

import { useEffect, useRef } from 'react'
import { cva } from 'class-variance-authority'

import { cn } from '@/lib/utils'
import { SubMenuLink } from '@/components/custom/header/mainmenu/subMenu/subMenuLink'
import {MainMenuItemModel} from "@/components/custom/header/mainmenu/mainMenuItem";
import {ActiveSubMenuItem} from "@/components/custom/header/mainmenu/subMenu/subMenu";

const listItemVariants = cva('menu-list__item flex cursor-pointer flex-row items-center transition-colors duration-300', {
    variants: {
        state: {
            active: 'active text-primary',
            current: "active text-cyan font-bold",
            inactive: ''
        }
    },
    defaultVariants: {
        state: 'inactive'
    }
})

const subMenuListClasses = {
    default: 'menu-list flex flex-col gap-y-2 transition-all duration-300 ease-in-out invisible -translate-x-3 opacity-0 lg:col-span-3',
    active: 'visible translate-x-0 opacity-100'
}

const listItemClasses = ``

interface SubMenuListProps {
    items: MainMenuItemModel[] | null | undefined;
    locale: string;
    level: number;
    activeSubMenuItem: ActiveSubMenuItem;
    currentSubMenuItem: ActiveSubMenuItem;
    setSubactive: (value: boolean) => void;
    handleSubMenuItems: (item: MainMenuItemModel | null, level: number) => void;
    setListHeights: (value: {}) => void;
    className?: string;
}

const SubMenuList = ({ items, locale, level, activeSubMenuItem, currentSubMenuItem, handleSubMenuItems, setListHeights, className, setSubactive }: SubMenuListProps) => {
    const listRef = useRef(null)

    useEffect(() => {
        // @ts-ignore
        const newHeight = { [level]: listRef.current.getBoundingClientRect().height }
        setListHeights((oldObj: any) => ({ ...oldObj, ...newHeight }))
    }, [items, level])

    return (
        <ul className={cn(subMenuListClasses['default'], items && subMenuListClasses['active'], className)} data-level={level} ref={listRef}>
            {items &&
                items.map((item) => (
                    <li
                        key={item.id}
                        onMouseOver={() => handleSubMenuItems(item, level)}
                        className={cn(listItemVariants({
                            state: item.id === currentSubMenuItem[level as keyof ActiveSubMenuItem].item ?
                                'current' :
                                item.id === activeSubMenuItem[level as keyof ActiveSubMenuItem].item ? 'active' : 'inactive'
                        }))}
                    >
                        <SubMenuLink item={item} setSubactive={setSubactive} />
                    </li>
                ))}
        </ul>
    )
}

export { SubMenuList }
